
import { Component, Vue,Prop,Watch } from 'vue-property-decorator'
import moment, { Moment } from 'moment'

@Component
export default class customIndex extends Vue {
    // @Prop()allNumber!: [] 
    @Prop({ type: Object, default: 0 }) allNumber!: []; // 接收父级传的值
    @Watch("allNumber") // 更新接收的值  ，不然只会显示第一次接收到的值
    watchAllNumber(newVal: any) {
        this.allNumber = newVal; // 作业
        console.log(this.allNumber,'子组件查看船只')
    }
    changeShowList(type){
        this.$emit('changeShowList',type)
    }
}
